import { GHOST_ICONS_LS_KEY_PREFIX } from './GHOST_ICONS_LS_KEY_PREFIX';

export const buildKey = (aaid: string): string => `${GHOST_ICONS_LS_KEY_PREFIX}${aaid}`;
